import { Agreement } from './Agreement';
import { AmountField } from './AmountField';
import { AutoSuggestions } from './AutoSuggestions';
import { Eligibility } from './Eligibility';
import { Form } from './Form';
import { SubmitButton } from './SubmitButton';

export default { Agreement, AmountField, AutoSuggestions, Eligibility, Form, SubmitButton };
